module.exports = "footer {\n  background-color: #fff;\n  padding-top: 20px;\n  text-align: center;\n  clear: both;\n  width: 100%; }\n  footer p {\n    line-height: 50px;\n    margin: 0;\n    padding: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/landing-page/common/landing-page-footer/landing-page-footer.component.scss
// module id = ./src/app/home/pages/landing-page/common/landing-page-footer/landing-page-footer.component.scss
// module chunks = main